import { Container } from '@material-ui/core';
import Page from '../components/Page';
import EmployerList from '../components/settings/EmployerList';

export default function Employers() {
  return (
    <Page title="Dashboard: Employers | ZIMTA">
      <Container>
        <EmployerList />
      </Container>
    </Page>
  );
}
